import Vue from 'vue'
import SessionStorage from '@/services/session-storage'

const state = {
  listaDisponibilidades: [],
  listaLocais: [],
  localEditar: [],
  disponibilidadeEditar: []
}

const mutations = {
  setLocais (state, data) {
    state.listaLocais = data
  },
  setLocalEditar (state, data) {
    state.localEditar = data
  },
  setDisponibilidades (state, data) {
    state.listaDisponibilidades = data
  },
  setDisponibilidadeEditar (state, data) {
    state.disponibilidadeEditar = data
  }
}

const actions = {
  buscarLocais (context) {
    Vue.http.get('api/local?usuario_id=' + SessionStorage.get('usuario')).then(response => {
      context.commit('setLocais', response.data.data)
    })
  },
  buscarLocaisParaVoluntario (context, data) {
    Vue.http.post('api/local/voluntarios', data).then(response => {
      context.commit('setLocais', response.data.data.locais)
    })
  },
  buscarDisponibilidades (context, id) {
    Vue.http.get('api/local/voluntarios/disponibilidades-voluntarios/' + id).then(response => {
      context.commit('setDisponibilidades', response.data.data)
    })
  },
  getLocal (context, id) {
    Vue.http.get('api/local/' + id).then(response => {
      context.commit('setLocalEditar', response.data.data[0])
    })
  },
  getDisponibilidade (context, id) {
    Vue.http.get('api/local/voluntarios/disponibilidade/' + id).then(response => {
      context.commit('setDisponibilidadeEditar', response.data.data[0])
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/local.js